import Vue from 'vue'
import router from "./router/router"
import App from './App'

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});




// WEBPACK FOOTER //
// ./src/main.js